import { render } from "./ClientReport.vue?vue&type=template&id=0dda8606&scoped=true"
import script from "./ClientReport.vue?vue&type=script&lang=js"
export * from "./ClientReport.vue?vue&type=script&lang=js"

import "./ClientReport.vue?vue&type=style&index=0&id=0dda8606&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dda8606"]])

export default __exports__